import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Helpers
import { isGtmTrackedPath, loadGtmScript } from 'helpers/googleTagManager';

/**
 * Carrega o Google Tag Manager apenas nas rotas do e-commerce (venda de
 * passagens) e apenas quando REACT_APP_GTM_CONTAINER_ID estiver definida no
 * ambiente (hoje: CatSul). Não renderiza nada.
 */
const GoogleTagManagerTracking: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (isGtmTrackedPath(pathname)) loadGtmScript();
  }, [pathname]);

  return null;
};

export default GoogleTagManagerTracking;
